import React from "react";
import { Card, Typography, Box } from "@mui/material";
import { AI_OPS_GRADIENTS, AI_OPS_SHADOWS } from "./_aiOpsTheme";

/**
 * KPI tile — gradient icon + label + value.
 * Used across all AI Ops stat banners.
 */
export default function KpiTile({
  label,
  value,
  accent = "indigo",
  icon: IconComp,
  warning = false,
  style = {},
}) {
  const gradient = AI_OPS_GRADIENTS[accent] || AI_OPS_GRADIENTS.indigo;
  const shadow   = AI_OPS_SHADOWS[accent]   || AI_OPS_SHADOWS.indigo;
  const valueColor = warning ? "#DC2626" : "#0F172A";

  return (
    <Card
      elevation={0}
      sx={{
        flex: "1 1 140px",
        border: "1px solid #E5E7EB",
        borderRadius: "16px",
        p: 2.5,
        position: "relative",
        overflow: "hidden",
        boxShadow: `0 4px 16px -6px ${shadow}30, 0 1px 3px ${shadow}18`,
        transition: "transform 0.15s, box-shadow 0.15s",
        "&:hover": { transform:"translateY(-2px)", boxShadow:`0 8px 24px -6px ${shadow}40` },
        ...style,
      }}
    >
      {/* Top accent stripe */}
      <Box sx={{ position:"absolute", top:0, left:0, right:0, height:3,
        background:`linear-gradient(90deg, ${gradient[0]}, ${gradient[1]})` }} />

      <Box sx={{ display:"flex", alignItems:"flex-start", gap:1.5, mt:0.5 }}>
        {IconComp && (
          <Box sx={{
            width: 40, height: 40, borderRadius: "11px", flexShrink: 0,
            background: `linear-gradient(135deg, ${gradient[0]} 0%, ${gradient[1]} 100%)`,
            color: "#fff", display:"flex", alignItems:"center", justifyContent:"center",
            boxShadow: `0 4px 10px ${shadow}45`,
          }}>
            <IconComp sx={{ fontSize: 20 }} />
          </Box>
        )}
        <Box sx={{ minWidth:0, flex:1 }}>
          <Typography sx={{
            fontSize: 10, fontWeight: 800, letterSpacing: 0.7,
            textTransform: "uppercase", color: shadow, lineHeight:1.1, mb: 0.6,
          }}>
            {label}
          </Typography>
          <Typography sx={{
            fontSize: 22, fontWeight: 800, color: valueColor,
            lineHeight: 1.15, wordBreak: "break-word",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          }}>
            {value}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}
